module.exports = __webpack_public_path__ + "media/images/front/review_star_04-f8137f7fd07debe401cd1c7ded67e5c4.png";